<template>
    <div class="accordion-item">
        <div :class="`acc-title-con ${!opened ? '' : 'opened'} ${currentItem === index && grouped ? 'opened': ''}`" @click.stop="grouped ? onSelectItem(index) : openAccordion()">
            {{ title }}
            <span class="sub-title">
                {{ subTitle }}
            </span>
            <svg height="22" width="22" :class="`t-icon lg icon-toggle ${currentItem === index ? 'minus': 'plus'}`"/>
        </div>
        <template v-if="grouped">
          <transition
            mode="out-in" name="accordion_group_fade"
            v-on:before-enter="agBeforeEnter"
            v-on:enter="agOnEnter"
          >
            <div class="accordion_group__copy" v-show="currentItem === index">
              <div v-if="!useSlotContent" class="accordion_group-copy-ct non-slotted" v-html="content"></div>
              <div v-else class="accordion_group-copy-ct slotted"><slot name="acc-content"></slot></div>
            </div>
          </transition>
        </template>
        <template v-else>
          <div :class="`acc-content-con animate__animated ${isHidden ? 'd-none' : ''} ${noHeight ? 'height-0' : ''} ${animateConditions}`" v-if="!useSlotContent" v-html="content"></div>
          <div v-else :class="`acc-content-con animate__animated ${isHidden ? 'd-none' : ''} ${noHeight ? 'height-0' : ''} ${animateConditions} ${customContainer ? 'custom-con' : ''} ${contentClass}`">
              <slot name="acc-content"></slot>
          </div>
        </template>
    </div>
</template>

<script>
    import SvgPointer from '@theme-views/common/SvgIcon/Icons/Pointer'
    import AccordionItem from '@views/common/AccordionItem/accordion_item'

    export default {
        mixins: [AccordionItem],
        components: {SvgPointer},
        data() {
          return {
            hasOpened: false,
            noHeight: false,
            isHidden: false,
            cdn_url: window.APP_CONFIG.CDN_URL
          }
        },
        methods: {
            openAccordion() {
                this.opened = !this.opened
                this.$emit('open-accordion')
                this.onCollapse()
            },
            onCollapse() {
                if(this.opened) {
                  this.isHidden = false
                  this.$nextTick(() => {
                    this.hasOpened = true
                    this.noHeight = false
                  })
                }else {
                  this.hasOpened = false
                    window.setTimeout(() => {
                      this.isHidden = true
                      this.noHeight = true
                    }, 500)
                }
            },
            onSelectItem: function(e) {
              this.$emit('onSelectItem', e)
            },
            agBeforeEnter: function(e) {
              this.$emit('agBeforeEnter', e)
            },
            agOnEnter: function(e) {
              this.$emit('agOnEnter', e)
            }
        },
        computed: {
          animateConditions() {
            return this.hasOpened ? 'animate__fadeInDown full-height' : 'animate__fadeOutUp'
          }
        },
        mounted() {
          if(this.opened) {
            this.isHidden = false
            this.$nextTick(() => {
              this.hasOpened = true
              this.noHeight = false
            })
          }else {
            this.noHeight = true
            this.isHidden = true
          }
        }
    }
</script>

<style lang="scss" src="./accordion_item.scss"></style>
